<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Clubstatus</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ng-container *ngFor="let lessonForm of states.controls; let i = index">
                        <div class="row " [formGroup]="lessonForm">
                            <div class="col-sm-3">
                                <mat-form-field class="full-width">
                                    <mat-label>Tag</mat-label>
                                    <input matInput formControlName="shortcode">
                                    <mat-error>
                                        Tag <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-6">
                                <mat-form-field class="full-width">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="longname">
                                    <mat-error>
                                        Name <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2" style="max-height: 56px;
                            display: flex;
                            align-items: center;">
                                <mat-checkbox formControlName="visible">
                                Sichtbar
                            </mat-checkbox>
                            </div>

                            <div class="col-sm-1 ">
                                <button mat-icon-button style="margin: 0 auto !important;"
                                    [matMenuTriggerFor]="menu" color="accent"
                                    >
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="deleteState(i)">
                                        Löschen
                                    </button>
                                </mat-menu>
                            </div>
                        </div>
                    </ng-container>
                    <button mat-raised-button color="accent" (click)="addState()">
                        Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                    </button>
                </mat-card-content>
                <mat-card-actions  align="end">
                    <button mat-button color="primary" (click)="saveChanges()">
                      Änderungen Speichern
                    </button>
                  </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>
<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>